import {
  EntityCategory,
  selectDetections,
  useDetectedEntitiesStore,
} from '../stores/useDetectedEntitiesStore';
import GroupedEntityData from './GroupedEntityData';
import { HeldFeedFieldsNote } from './HeldFeedFieldsNote';
import SimpleEntityData from './SimpleEntityData';
import { memo } from 'react';

type Props = {
  entityType: string;
  category: EntityCategory;
};

function EntityDataPanel({ entityType, category }: Props) {
  const detections = useDetectedEntitiesStore(state =>
    selectDetections(state, category, entityType),
  );

  if (detections.length === 0) {
    return null;
  }

  if (detections[0].isConflictable) {
    return (
      <>
        <HeldFeedFieldsNote detections={detections} />
        <GroupedEntityData entityType={entityType} category={category} />
      </>
    );
  }

  return (
    <>
      <HeldFeedFieldsNote detections={detections} />
      <SimpleEntityData detectionId={detections[0].id} category={category} />
    </>
  );
}

export default memo(EntityDataPanel);
